import { Box } from "@mui/material";
import ChatContent from "./components/ChatContent";

const ChatConnectPage = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        mt: { xs: 4, sm: 6 },
        mx: "auto",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <ChatContent />
    </Box>
  );
};

export default ChatConnectPage;
